// Meta Pixel helpers — every call is a safe no-op if the pixel hasn't loaded
// (ad blockers, script failures) so shopping never breaks.
export const fbq = (...args) => {
  if (typeof window !== "undefined" && window.fbq) window.fbq(...args);
};

export const track = (event, data, eventId) => {
  fbq("track", event, data, eventId ? { eventID: eventId } : undefined);
};

export const getFbp = () => {
  const m = document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
};

export const getFbc = () => {
  const m = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
};
